import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Savingsinstallmentchange } from "../../savingsinstallmentchange/shared/savingsinstallmentchange";

@Injectable({
  providedIn: 'root'
})
export class SavingsinstallmentchangeService {

  public selectedSavingsinstallmentchange: Savingsinstallmentchange;
  public SavingsinstallmentchangeList: Savingsinstallmentchange[];

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDInstallmentChange(savingsinstallmentchange:Savingsinstallmentchange){

    savingsinstallmentchange.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    savingsinstallmentchange.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    savingsinstallmentchange.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    savingsinstallmentchange.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body = savingsinstallmentchange;
    
    // console.log(body);
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SavingsInstallmentChange/IUD', body, { headers: headers });

    }

  FetchInstallmentChangeById(savingsinstallmentchange) {

    savingsinstallmentchange.Id = + savingsinstallmentchange.Id;
    savingsinstallmentchange.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    savingsinstallmentchange.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    savingsinstallmentchange.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    savingsinstallmentchange.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = savingsinstallmentchange;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SavingsInstallmentChange/Fetch', body, { headers: headers });
  }

  FetchInstallmentChangeList(){
 
    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SavingsInstallmentChange/FetchList', body, { headers: headers });
  }
}
